(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[761],{

/***/ 4127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sale",
      function () {
        return __webpack_require__(7753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6528);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);





function KeysNewComponent() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("keys").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container align-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: "".concat((_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default().keys), " row"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "delivery",
                            srcSet: "https://public.choose.app/website/2023/Delivery@2x.png 2x,https://public.choose.app/website/2023/Delivery@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Delivery.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("delivery")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Notifications@2x.png 2x,https://public.choose.app/website/2023/Notifications@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Notifications.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("retour")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Paiement@2x.png 2x,https://public.choose.app/website/2023/Paiement@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Paiement.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("payment")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/ServiceClient@2x.png 2x,https://public.choose.app/website/2023/ServiceClient@3x.png 3x",
                            src: "https://public.choose.app/website/2023/ServiceClient.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("support")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (KeysNewComponent);


/***/ }),

/***/ 2971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _App_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(575);
/* harmony import */ var _App_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_App_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);
/* harmony import */ var _utils_agent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9754);
/* harmony import */ var _utils_lang__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3703);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1936);









function AppNewComponent(props) {
    var onClickApple = function onClickApple() {
        (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .trackEventSegment */ .P)("clickApple");
    };
    var onclickAndroid = function onclickAndroid() {
        (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .trackEventSegment */ .P)("clickAndroid");
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), userAgent = ref[0], setUserAgent = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var ua = (0,_utils_agent__WEBPACK_IMPORTED_MODULE_4__/* .getUserAgent */ .i)();
        setUserAgent(ua);
    }, []);
    var ref1 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common"), t = ref1.t, i18n = ref1.i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().app), " ").concat(props.className || ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("app")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().stores),
                            children: [
                                userAgent.isMobile && !userAgent.isAndroid || !userAgent.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            onClick: onClickApple,
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().big), " plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=app"),
                                            title: "Apple Store",
                                            href: "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                width: "182",
                                                height: "54",
                                                alt: "Apple Store",
                                                src: "https://public.choose.app/website/new/images/btn-big-app-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().small), " plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=app"),
                                            onClick: onClickApple,
                                            title: "Apple Store",
                                            href: "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                width: "134",
                                                height: "40",
                                                alt: "Apple Store",
                                                src: "https://public.choose.app/website/new/images/btn-small-app-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        })
                                    ]
                                }) : null,
                                userAgent.isMobile && userAgent.isAndroid || !userAgent.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: onclickAndroid,
                                            href: "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR",
                                            rel: "noreferrer",
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().big), " plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=app"),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                width: "182",
                                                height: "54",
                                                alt: "Play Store",
                                                src: "https://public.choose.app/website/new/images/btn-big-play-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: onclickAndroid,
                                            href: "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR",
                                            rel: "noreferrer",
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().small), " plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=app"),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                height: "41",
                                                width: "136",
                                                alt: "Play Store",
                                                src: "https://public.choose.app/website/new/images/btn-small-play-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    width: "177",
                    height: "177",
                    alt: "HeartRotate",
                    src: "https://public.choose.app/website/new/images/HeartRotate.png",
                    srcSet: "https://public.choose.app/website/new/images/HeartRotate@2x.png 2x,https://public.choose.app/website/new/images/HeartRotate@3x.png 3x"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppNewComponent);


/***/ }),

/***/ 7753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1151);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(619);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6002);
/* harmony import */ var _styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6511);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5350);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2251);
/* harmony import */ var _components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6514);
/* harmony import */ var _new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5374);
/* harmony import */ var _new_components_header_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5365);
/* harmony import */ var _new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8205);
/* harmony import */ var _new_components_sale_App_App__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2971);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1936);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3496);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1340);
/* harmony import */ var _utils_lang__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3703);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8579);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_10__);




















var SaleScreen = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(SaleScreen, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(SaleScreen);
    function SaleScreen() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(this, SaleScreen);
        var _this;
        _this = _super.apply(this, arguments);
        _this.getTrad = function(str) {
            return _this.props.t(str);
        };
        _this.getImage = function(param) {
            var src = param.src, width = param.width;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_14__/* .transformImage */ .W)(src, width + "x");
        };
        return _this;
    }
    var _proto = SaleScreen.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var ref;
        (0,_api__WEBPACK_IMPORTED_MODULE_15__/* .trackPage */ .K)("Vente");
        document.title = "Choose X " + ((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.name);
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sale),
            children: [
                this.props.sale ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    pageTitle: this.getTitle,
                    canonical: _config__WEBPACK_IMPORTED_MODULE_17__/* .canonical */ .fK + "sales/" + this.props.sale.url,
                    appleArguments: this.getAppleMeta,
                    keywords: this.props.sale.name,
                    description: this.getDescription.replace(/<b>/g, "").replace(/<\/b>/g, ""),
                    title: this.getTitle,
                    image: this.getMainImage,
                    noIndex: true
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_header_Header__WEBPACK_IMPORTED_MODULE_6__/* .HeaderNewComponent */ .w, {
                    showSlogan: true,
                    disableScroll: true,
                    hideBtns: true,
                    store: this.props.store,
                    language: this.props.i18n.language
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container align-items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sale_data)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                    className: "col-7 col-sm-12 col-md-12 ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().image)),
                                    loader: this.getImage,
                                    layout: "fixed",
                                    src: this.props.sale && this.props.sale.image_header ? this.props.sale.image_header : "",
                                    alt: "image ".concat((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.name),
                                    width: 708,
                                    height: 386
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-0 col-1 col-md-0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-4 col-sm-12 col-md-10 ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sale_info)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            children: (ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().category),
                                            children: (ref2 = this.props.sale) === null || ref2 === void 0 ? void 0 : ref2.category
                                        }),
                                        ((ref3 = this.props.sale) === null || ref3 === void 0 ? void 0 : ref3.badges) && ((ref4 = this.props.sale) === null || ref4 === void 0 ? void 0 : ref4.sale_started) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().badges),
                                            children: (ref5 = this.props.sale) === null || ref5 === void 0 ? void 0 : ref5.badges.map(function(badge) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().badge),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                            height: "16",
                                                            width: "16",
                                                            disableWebp: true,
                                                            src: badge.image,
                                                            alt: badge.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: _this.props.t(badge.code)
                                                        })
                                                    ]
                                                }, badge.text);
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().date),
                                            dangerouslySetInnerHTML: {
                                                __html: this.getText
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_sale_App_App__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().app)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sale_hr)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    store: this.props.store
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: this.setSchema
                })
            ]
        });
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(SaleScreen, [
        {
            key: "getTitle",
            get: function get() {
                if (this.props.sale) {
                    if (this.props.sale.sale_ended) {
                        return "".concat(this.props.sale.name, " | ").concat(this.getTrad("sale_ongoing"));
                    }
                    return "".concat(this.props.sale.name, " |\xa0").concat(this.getTrad("sale_ongoing"));
                }
                return "";
            }
        },
        {
            key: "getDescription",
            get: function get() {
                var description = "";
                if (this.props.sale.sale_ended) {
                    description = "".concat(this.getTrad("sale_delivery"));
                } else if (this.props.sale.sale_started) {
                    description = "".concat(this.getTrad("basic"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_19__/* .formatPublicHome */ .kC)(this.props.sale.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_20__/* .getLang */ .V)(this.props.i18n), this.props.sale.store), ". ").concat(this.getTrad("sale_delivery"));
                } else {
                    description = "".concat(this.getTrad("basic"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_19__/* .formatNextHome */ .Ec)(this.props.sale.start_at, this.props.sale.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_20__/* .getLang */ .V)(this.props.i18n), this.props.sale.store), ". ").concat(this.getTrad("sale_delivery"));
                }
                // Remove any <b> and </b> tags from the description
                return description.replace(/<b>/g, "").replace(/<\/b>/g, "");
            }
        },
        {
            key: "getMainImage",
            get: function get() {
                if (this.props.sale && this.props.sale.image_header) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_14__/* .transformImage */ .W)(this.props.sale.image_header, "1200");
                // return `https://img.appchoose.io/unsafe/1200x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
                //   this.props.sale.dark_color ? "white" : "black"
                // }.png,443,272,50)/prod/${
                //   this.props.sale.image_header.split("/prod/")[1]
                // }`;
                }
                return "";
            }
        },
        {
            key: "getAppleMeta",
            get: function get() {
                var path = this.props.router.asPath.replace("/", "").replace("sale/", "sales/").replace("tester/", "sales/").replace("upcoming/", "sales/");
                if (path.includes("?")) {
                    path = path.split("?")[0];
                }
                var newLocation = "chooseapp://".concat(encodeURI(path));
                if (this.props.router.asPath.match(/(sales|sale)/) && this.props.sale && !this.props.sale.sale_started) {
                    newLocation = "chooseapp://".concat(encodeURI(path.replace("sales", "preview")));
                }
                return newLocation;
            }
        },
        {
            key: "getText",
            get: function get() {
                if (this.props.sale) {
                    if (this.props.sale.sale_ended) {
                        return this.getTrad("sale_ended");
                    } else if (this.props.sale.sale_started) {
                        return "".concat(this.getTrad("sale_ongoing"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_19__/* .formatPublicHome */ .kC)(this.props.sale.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_20__/* .getLang */ .V)(this.props.i18n), this.props.sale.store));
                    }
                    return "".concat(this.getTrad("sale_next"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_19__/* .formatNextHome */ .Ec)(this.props.sale.start_at, this.props.sale.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_20__/* .getLang */ .V)(this.props.i18n), this.props.sale.store));
                }
                return "";
            }
        },
        {
            key: "setSchema",
            get: function get() {
                return {
                    __html: this.props.sale ? '{"@context": "http://schema.org",\n                "@type": "SaleEvent",\n                  "startDate": "'.concat(this.props.sale.start_at, '",\n                   "endDate": "').concat(this.props.sale.end_at, '",\n                   "location":"appchoose.io",\n                   "description": "').concat(this.getDescription.replace(/<b>/g, "").replace(/<\/b>/g, ""), '",\n                  "name": "').concat(this.props.sale.name ? this.props.sale.name.replace(/"/g, "").replace(/(\r\n|\n|\r)/gm, " ") : null, '",\n                  "image":"').concat(this.getMainImage, '",\n                  "url": "').concat(_config__WEBPACK_IMPORTED_MODULE_17__/* .canonical */ .fK, "sales/").concat(this.props.sale.url, '"\n            }').replace(/\n/g, "") : ""
                };
            }
        }
    ]);
    return SaleScreen;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .withTranslation */ .Zh)("sale")((0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(SaleScreen)));


/***/ }),

/***/ 2251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ formatBasic; },
/* harmony export */   "Ec": function() { return /* binding */ formatNextHome; },
/* harmony export */   "kC": function() { return /* binding */ formatPublicHome; }
/* harmony export */ });
/* unused harmony exports formatEnd, addDays, differenceInMinutes, differenceInHours, differenceInDays, isWeekend */
var formatEnd = function(endAt) {
    var d = new Date();
    var diff = differenceInDays(d, endAt);
    if (diff > 1) {
        return "".concat(diff, " jours restants");
    }
    var diffHours = differenceInHours(d, endAt);
    if (diffHours > 24) {
        return "1 jour restant";
    }
    if (diffHours > 1) {
        return "".concat(diffHours, "h restantes");
    }
    return "1h restante";
};
var formatBasic = function(endAt, lang, store) {
    var d = new Date(endAt);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    return d.toLocaleDateString(LOCALE, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined
    });
};
var formatPublicHome = function(end_at, lang, store) {
    var endAt = new Date(end_at);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    var month = endAt.toLocaleDateString(LOCALE, {
        month: "long",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined,
        weekday: "short",
        day: "numeric",
        hour: store === "us" ? "numeric" : undefined
    });
    var diff = Math.abs(differenceInHours(new Date(), endAt));
    var res = "";
    if (diff <= 24) {
        res = lang === "fr" ? "jusqu'\xe0 demain" : "until tomorrow";
    } else if (diff <= 48) {
        res = lang === "fr" ? "jusqu'apr\xe8s-demain" : "until the day after tomorrow";
    } else {
        res = lang === "fr" ? "jusqu'au ".concat(month) : "until ".concat(month);
    }
    return "<b>" + res + "</b>";
};
var formatNextHome = function(start_at, end_at, lang, store) {
    var startAt = new Date(start_at);
    var endAt = new Date(end_at);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    // const dayEnd = endAt.toLocaleDateString(LOCALE, { weekday: 'long' });
    var dayEnd = endAt.toLocaleDateString(LOCALE, {
        month: "long",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined,
        weekday: "short",
        day: "numeric",
        hour: store === "us" ? "numeric" : undefined
    });
    var diff = differenceInHours(new Date(), startAt);
    var res = "";
    if (diff <= 24) {
        res = lang === "fr" ? "de demain au ".concat(dayEnd) : "from tomorrow to ".concat(dayEnd);
    } else if (diff <= 48) {
        res = lang === "fr" ? "d'apr\xe8s-demain au ".concat(dayEnd) : "from the day after tomorrow to ".concat(dayEnd);
    } else {
        var day = startAt.toLocaleDateString(LOCALE, {
            weekday: "long",
            day: "numeric",
            timeZone: "UTC"
        });
        res = lang === "fr" ? "du ".concat(day, " au ").concat(dayEnd) : "from ".concat(day, " to ").concat(dayEnd);
    }
    return "<b>" + res + "</b>";
};
var addDays = function(date, days) {
    return new Date(date.getTime() + days * 60000 * 24 * 60);
};
var differenceInMinutes = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60);
};
var differenceInHours = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60 / 60);
};
var differenceInDays = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60 / 60 / 24);
};
var isWeekend = function(date) {
    var day = date.getDay();
    return day === 6 || day === 0;
};


/***/ }),

/***/ 5350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ transformImage; }
/* harmony export */ });
var transformImage = function(image, sizes, removeFit, _webP) {
    if (image) {
        image = image.replace(":format(webp)", "").replace("resize:fit", "resize:fill");
        if (removeFit) {
            image = image.replace("full-fit-in/", "").replace("fit-in/", "");
        }
        return image.replace("[W]x[H]/", sizes + "/");
    }
    return "";
};


/***/ }),

/***/ 6528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keys":"Keys_keys__HpzY5"};

/***/ }),

/***/ 575:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__tJ585","stores":"App_stores__NpcYj","small":"App_small__001jb","big":"App_big__6kFAu","content":"App_content__H7Y49","text":"App_text__NIw_B"};

/***/ }),

/***/ 6002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sale":"sale_sale__wSg8c","prices":"sale_prices__qXF57","pricesproduct":"sale_pricesproduct__Tsnsi","discount":"sale_discount__1cslx","price_formatted":"sale_price_formatted__vsT2H","price_normal":"sale_price_normal__IJcnb","price_normal_eee":"sale_price_normal_eee__R6grx","tester":"sale_tester__IBTWH","sizes":"sale_sizes__Jmanb","margin":"sale_margin__wTO1F","hrlight":"sale_hrlight__vzcOJ","cguText":"sale_cguText__epXWa","cgu":"sale_cgu__i47Qt","sale_data":"sale_sale_data__2JMT9","product_data":"sale_product_data__0r9Vn","sale_info":"sale_sale_info__33qiu","stock":"sale_stock__dgg5M","breadcrump":"sale_breadcrump__UV1gL","products":"sale_products__ggtB8","badges":"sale_badges__S_adm","details":"sale_details__jLyR1","description":"sale_description__qyXGY","date":"sale_date___KEci","giveaway":"sale_giveaway__NumkQ","delivery":"sale_delivery__ok3rv","instagram":"sale_instagram__P7HLl","sale_hr":"sale_sale_hr__REAy7","badge":"sale_badge__07QCE","separation":"sale_separation__ZVKuY","carousel":"sale_carousel__Kp7TX","image":"sale_image__QP9WL","app":"sale_app__IyPAb","title_brand":"sale_title_brand__PBbHe","title_product":"sale_title_product__NutSy","category":"sale_category__vJSO9"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [195,155,530,975,774,888,179], function() { return __webpack_exec__(4127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);